var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 22.5334C9.3722 22.5334 4.66348 21.6245 4.66348 21.6245L4.65163 21.6109C2.99931 21.3467 1.7334 19.9268 1.7334 18.2001V13.0001V12.9984V7.80011V7.79842C1.73501 6.97376 2.03055 6.17668 2.56696 5.5503C3.10336 4.92393 3.84549 4.50929 4.66009 4.38084L4.66348 4.37576C4.66348 4.37576 9.3722 3.46509 13.0001 3.46509C16.6279 3.46509 21.3367 4.37576 21.3367 4.37576L21.3383 4.37746C22.1538 4.50563 22.8968 4.9206 23.4336 5.54772C23.9704 6.17483 24.2659 6.97293 24.2667 7.79842V7.80011V12.9984V13.0001V18.2001C24.2655 19.0251 23.9702 19.8226 23.4337 20.4493C22.8973 21.076 22.1549 21.4909 21.34 21.6194L21.3367 21.6245C21.3367 21.6245 16.6279 22.5334 13.0001 22.5334ZM10.4001 16.9881L17.3334 13.0001L10.4001 9.01209V16.9881Z",
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.db2a53c7022d33edc1241e919b064bc0.svg";
export { ForwardRef as ReactComponent };